import * as types from "../constants/actionTypes";

export const clearContext = () => ({
  type: types.CLEAR_CONTEXT
});
export const startProcessing = () => ({ type: types.START_PROCESSING });
export const stopProcessing = () => ({ type: types.STOP_PROCESSING });
export const setHasMultipleGroupCompanies = hasMultipleGroupCompanies => ({
  type: types.SET_HAS_MULTIPLE_GROUP_COMPANIES,
  hasMultipleGroupCompanies
});
export const setGroupCompanyId = groupCompanyId => ({
  type: types.SET_GROUP_COMPANY_ID,
  groupCompanyId
});
export const setProjectId = projectId => ({
  type: types.SET_PROJECT_ID,
  projectId
});
export const setProject = project => ({
  type: types.SET_PROJECT,
  project
});
